import React from 'react';

import {Helmet} from 'views/module';
import RoutinesScene from 'views/scenes/routines/RoutinesScene';

const Routines = () => (
  <>
    <Helmet>
      <title>Quilt: Routines</title>
    </Helmet>
    <RoutinesScene />
  </>
);

export default Routines;
